'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ArrowCarousel = require('../../global/components/carousel/views/ArrowCarousel');
const SwipeCarousel = require('../../global/components/carousel/views/SwipeCarousel');

class HomepageCarousel extends React.Component {
    constructor() {
        super();

        this.trackImpressions = this.trackImpressions.bind(this);
        this.onPageChange = this.onPageChange.bind(this);

        this.state = {
            hasTrackingFired: {}
        };
    }

    componentDidMount() {
        this.trackImpressions(0);
    }

    onPageChange(page, variant) {
        this.props.onPageChange(page, variant);
        this.trackImpressions(page);
    }

    trackImpressions(page) {
        const {hasTrackingFired} = this.state;
        const {itemsPerPage} = this.props;

        if (!hasTrackingFired[page]) {

            const startIndex = page * itemsPerPage;
            const visibleItems = this.props.items.slice(startIndex, startIndex + itemsPerPage);

            this.props.onImpression(visibleItems, startIndex);

            hasTrackingFired[page] = true;

            this.setState({
                hasTrackingFired
            });
        }
    }

    buildChildren() {
        return this.props.items.map((item, index) => {
            return React.cloneElement(this.props.children, {
                key: item.id || item.url,
                item,
                index
            });
        });
    }

    render() {
        const carouselProps = {
            auto: this.props.auto,
            ref: this.props.carouselRef,
            transitionEffect: this.props.transitionEffect,
            customTransformItemStyle: this.props.customTransformItemStyle,
            autoDuration: this.props.autoDuration,
            useDotsNav: this.props.useDotsNav,
            dotsColorType: this.props.dotsColorType,
            itemsPerPage: this.props.itemsPerPage,
            itemWidth: this.props.itemWidth,
            isCentered: this.props.isCentered,
            children: this.buildChildren(),
            classNames: this.props.classNames,
            onDotClick: this.props.onDotClick,
            onPageChange: this.onPageChange
        };

        if (this.props.isMobile) {
            return <SwipeCarousel {...carouselProps}/>;
        }

        return <ArrowCarousel {...carouselProps}/>;
    }
}

HomepageCarousel.defaultProps = {
    auto: false,
    autoDuration: 5000,
    useDotsNav: false,
    dotsColorType: 'buyer',
    itemsPerPage: 1,
    isCentered: false,
    onPageChange: function () {},
    carouselRef: function () {},
    onImpression: function () {},
    classNames: {
        list: 'hero-carousel-list',
        item: 'hero-carousel-panel',
        dot: 'hero-carousel-dot'
    }
};

HomepageCarousel.propTypes = {
    auto: PropTypes.bool,
    autoDuration: PropTypes.number,
    useDotsNav: PropTypes.bool,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    itemsPerPage: PropTypes.number,
    itemWidth: PropTypes.number,
    isCentered: PropTypes.bool,
    classNames: PropTypes.object,
    items: PropTypes.array,
    children: PropTypes.object,
    onImpression: PropTypes.func,
    onPageChange: PropTypes.func,
    carouselRef: PropTypes.func,
    onDotClick: PropTypes.func,
    isMobile: PropTypes.bool,
    transitionEffect: PropTypes.string,
    customTransformItemStyle: PropTypes.func
};

module.exports = HomepageCarousel;



// WEBPACK FOOTER //
// ./assets/js/home/components/HomepageCarousel.jsx